import React, { memo } from 'react'
import { useTheme } from '@maas-components/styles'
import PropTypes from 'prop-types'
import { Box, Typography, ColorfulProgress } from 'core/components/Core'

const AppLoading = ({ message }) => {
  const theme = useTheme()

  return (
    <Box
      alignItems="center"
      bgcolor="transparent"
      display="flex"
      height="100vh"
      justifyContent="center"
      flexDirection="column"
      zIndex={theme.zIndex.drawer + 1}
    >
      <ColorfulProgress size={60} />
      {message && <Typography>{message}</Typography>}
    </Box>
  )
}

AppLoading.propTypes = {
  message: PropTypes.string,
}

AppLoading.defaultProps = {
  message: '',
}

export default memo(AppLoading)
